import type { Schema } from '@biteinc/common';

export const magicCopyOptionsSchema: Schema.Model = {
  displayName: 'Magic Copy Options',
  type: 'object',
  fields: {
    recommendationRules: {
      type: 'bool',
      displayName: 'Recommendation Rules',
      tooltip: {
        text: 'Destructive action to replace target recommendation rule documents. Select Recommendation Variations too to copy variation rule references.',
        isWarning: true,
      },
    },
    recommendationVariations: {
      type: 'bool',
      displayName: 'Recommendation Variations',
      tooltip: {
        text: 'Copy variation data and rule references from recommendation variations. Rules have a dedicated option.',
      },
    },
    // This field will be disabled if the source location has a pos i9n
    pricesAndTaxes: {
      type: 'bool',
      displayName: 'Prices and Taxes',
      tooltip: {
        text: 'Use with caution because prices and taxes are prone to change based on address. Only available for non-POS integrated locations.',
        isWarning: true,
      },
    },
    taxes: {
      type: 'bool',
      displayName: 'Taxes Only',
      tooltip: {
        text: 'Use with caution because taxes are prone to change based on address. Only available for POS integrated locations that use manual tax profiles.',
        isWarning: true,
      },
    },
    menus: {
      type: 'bool',
      defaultValue: true,
      displayName: 'Menus',
      tooltip: {
        text: 'All menu data such as sections, items, groups and mods will be copied.',
      },
    },
    dayParts: {
      type: 'bool',
      defaultValue: true,
      displayName: 'Day Parts',
      tooltip: {
        text: 'Day parts will be created. Day parts will only be removed if "Menus" are also being copied.',
      },
    },
    menuCovers: {
      type: 'bool',
      defaultValue: true,
      displayName: 'Menu Covers',
    },
    badgesAndWords: {
      type: 'bool',
      defaultValue: true,
      displayName: 'Badges and Dictionary Words',
    },
    coupons: {
      type: 'bool',
      defaultValue: true,
      displayName: 'Coupons',
      tooltip: {
        text: '"Coupon Provider", "Coupons have barcode" and "Transform Coupon Codes" settings are also copied.',
      },
    },
    featureSettings: {
      type: 'bool',
      defaultValue: true,
      displayName: 'Feature Settings',
      tooltip: {
        text: 'Show Guest Survey, Show Page Navigation, Intro Images, Closed Cover Images, Map Base Layer, UI for Tall Screens, Special Requests, Text Size picker, Kiosk Sound Alerts, Coupon Provider, Coupons have barcode, Transform Coupon Codes',
      },
    },
    fulfillmentSettings: {
      type: 'bool',
      defaultValue: true,
      displayName: 'Fulfillment Settings (only if order channel matches)',
      tooltip: {
        text: 'Dining Options, Allow email receipts, Email Receipt Header Image',
      },
    },
    openHours: {
      type: 'bool',
      defaultValue: true,
      displayName: 'Open Hours (only if order channel matches)',
      tooltip: {
        text: 'Open Hours will be copied.',
      },
    },
    receiptSettings: {
      type: 'bool',
      defaultValue: true,
      displayName: 'Receipt Settings',
    },
    paymentSettings: {
      type: 'bool',
      defaultValue: true,
      displayName: 'Payment Details',
      tooltip: {
        text: 'Min/Max Transaction Amount, Payment Terminal Idle Text, Allow paying with cash (if available), Allow tips (if available)',
      },
    },
    presentationSettings: {
      type: 'bool',
      defaultValue: true,
      displayName: 'Presentation Settings',
      tooltip: {
        text: 'Appearance, Default Text Size, Price Style, Show $ in front of prices, Footnotes, Custom Strings',
      },
    },
    languageSettings: {
      type: 'bool',
      defaultValue: true,
      displayName: 'Language Settings',
      tooltip: {
        text: 'Supported Languages, Translations',
      },
    },
    commonSettingsV2: {
      type: 'bool',
      defaultValue: true,
      displayName: 'Common Settings',
      tooltip: {
        text: 'Brand Name, Nutrition Info, Hidden Items',
      },
    },
    kioskSettingsV2: {
      type: 'bool',
      defaultValue: true,
      displayName: 'Kiosk Settings',
      tooltip: {
        text: 'Order Mode, Cover Images, ADA',
      },
    },
    flashSettingsV2: {
      type: 'bool',
      defaultValue: true,
      displayName: 'Flash Settings',
      tooltip: {
        text: 'Custom account settings, disclaimers',
      },
    },
    recommendationSettingsV2: {
      type: 'bool',
      defaultValue: true,
      displayName: 'Recommendation Settings',
      tooltip: {
        text: 'Visibility Level for Per-Item Upsell, Show At-Checkout Upsell',
      },
    },
    quizSettings: {
      type: 'bool',
      defaultValue: true,
      displayName: 'Quiz Settings',
      tooltip: {
        text: 'Quiz Steps and Quizzes. IMPORTANT: Useless if badges are not copied.',
      },
    },
    integrations: {
      type: 'bool',
      defaultValue: true,
      displayName: 'Integrations',
      tooltip: {
        text: 'Only affects Brink "Discount Mappings"! Existing integration at target will be updated, but no integration will be created.',
        isWarning: true,
      },
    },
  },
};
